import { CloseCircleFilled, TickCircleFilled } from "@aircall/icons";

import { BinaryAnswerValue } from "@/graphql/generated/graphql";
import { ExcludeNotApplicable } from "../EvaluationResult/EvaluationResult.decl";

export function pickIcon(value: ExcludeNotApplicable<BinaryAnswerValue>) {
  switch (value) {
    case "YES":
      return TickCircleFilled;
    case "NO":
      return CloseCircleFilled;
    default:
      return null;
  }
}
